<div class="step-container">
  <!-- Success -->
  <div *ngIf="success" class="result-card success">
    <mat-icon class="result-icon success-icon">check_circle</mat-icon>
    <h2 class="result-title">¡Listo!</h2>
    <p class="result-message">
      Tus datos han sido actualizados con éxito.
    </p>
    <p class="result-hint">Ya podés cerrar esta ventana.</p>
  </div>

  <!-- Failure -->
  <div *ngIf="!success" class="result-card failure">
    <mat-icon class="result-icon failure-icon">cancel</mat-icon>
    <h2 class="result-title">Hubo un problema</h2>
    <p class="result-message">
      No pudimos realizar todas las verificaciones. Contactate con nosotros
      al <a href="tel:08102225566">0810-222-5566</a> o al
      <a href="tel:02320496784">02320-496784</a>.
    </p>
    <p class="result-hint">Podés cerrar esta ventana.</p>
  </div>
</div>
